// src/utils/geolocation.js

/**
 * Obtiene una posición con alta precisión.
 * Reintenta hasta cumplir un umbral de precisión (en metros) o agotar intentos.
 *
 * @param {number} maxAttempts Número máximo de intentos (por defecto 5)
 * @param {number} desiredAccuracy Umbral de precisión en metros (por defecto 30m)
 * @returns {Promise<GeolocationCoordinates>}
 */
export async function getAccurateLocation(
  maxAttempts = 5,
  desiredAccuracy = 30
) {
  let lastCoords = null;

  for (let i = 0; i < maxAttempts; i++) {
    const coords = await new Promise((resolve, reject) => {
      if (!navigator.geolocation) {
        reject(new Error('Geolocalización no soportada'));
      }
      navigator.geolocation.getCurrentPosition(
        (pos) => resolve(pos.coords),
        (err) => reject(err),
        {
          enableHighAccuracy: true,
          timeout: 10000,
          maximumAge: 0,
        }
      );
    });

    lastCoords = coords;
    // Si la precisión es buena, salimos
    if (coords.accuracy <= desiredAccuracy) {
      return coords;
    }
    // Si no, esperamos un segundo antes de reintentar
    await new Promise((r) => setTimeout(r, 1000));
  }

  // Si nunca alcanzó el umbral mínimo, devolvemos la última lectura
  return lastCoords;
}
